module.exports = __webpack_public_path__ + "static/media/logo.5ed3778f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 168
// module chunks = 0